<template>
  <z-dialog :show="isVisible" :modal-size="modalSize">
    <template #header>
      <div class="custom-header">
        <div class="row">
          <div class="col-md-11">
            <h4 class="modal-title">JSON Data</h4>
          </div>
          <div class="col-md-1">
            <a href="#" class="custom-close" @click="close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </div>
    </template>
    <template #body>
      <div class="custom-json">
        <json-viewer :value="jsondata" copyable />
      </div>
    </template>
    <template #footer>
      <button type="button" class="btn btn-light" @click="close()">Okay</button>
    </template>
  </z-dialog>
</template>
<script>
import { JsonViewer } from 'vue3-json-viewer'
import 'vue3-json-viewer/dist/index.css'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
export default {
  name: 'DialogViewJson',
  components: {
    JsonViewer,
    ZDialog
  },
  props: {
    modelValue: {
      type: Object
    }
  },
  data() {
    return {
      modalSize: 'modal-md'
    }
  },
  emits: ['input', 'closing', 'send'],
  computed: {
    isVisible: {
      get() {
        let _is = false
        if (this.modelValue) {
          _is = true
        }
        return _is
      }
    },
    jsondata() {
      return this.modelValue
    }
  },
  methods: {
    close() {
      this.$emit('closing')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
.custom-subtitle {
  font-size: 0.9em;
}
.custom-json {
  width: 100%;
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 500px;
}
</style>
